import { useField } from "formik";
import { FormInputProps } from "interfaces/formElements";
import React from "react";
import { FaEyeSlash, FaEye } from "react-icons/fa";
import {
  Container,
  ErrorSpan,
  Label,
  PasswordToggleContainer
} from "../styles";
import colors from "styles/colors";

interface TextInputProps extends FormInputProps {
  value?: string;
  disabled?: boolean;
  isErrorCheck?: boolean;
  autocomplete?: string;
  maxLength?: number;
  onChange?: (event: React.ChangeEvent<HTMLInputElement>) => void;
  onInput?: (event: React.ChangeEvent<HTMLInputElement>) => void;
  onKeyDown?: (event: React.KeyboardEvent<HTMLInputElement>) => void;
  isRequired?: boolean;
}

const PasswordInputComponent: React.FC<TextInputProps> = ({
  isErrorCheck = true,
  title,
  value,
  disabled,
  onChange,
  isRequired,
  ...props
}) => {
  const [field, meta] = useField(props);
  const [passwordShow, setPasswordShow] = React.useState(false);
  return (
    <Container className={`${meta.touched && meta.error ? "error" : ""}`}>
      <Label>
        {title}
        {isRequired && <span style={{ color: colors.error }}>*</span>}{" "}
      </Label>
      <PasswordToggleContainer>
        <input
          defaultValue={value}
          disabled={disabled}
          type={passwordShow ? "text" : "password"}
          {...field}
          onChange={(e) => {
            if (typeof onChange === "function") {
              onChange(e);
            }
            /* @HINT: `onChange` for <Formik /> from `useField()` */
            if (!e.defaultPrevented) {
              field.onChange(e);
            }
          }}
          {...props}
        />

        <p onClick={() => setPasswordShow(!passwordShow)}>
          {passwordShow ? (
            <FaEyeSlash color="#5e5b6e" />
          ) : (
            <FaEye color="#5e5b6e" />
          )}
        </p>
      </PasswordToggleContainer>

      {isErrorCheck && meta.touched && meta.error ? (
        <ErrorSpan>{meta.error}</ErrorSpan>
      ) : null}
    </Container>
  );
};

export default PasswordInputComponent;
